import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { start } from "@popperjs/core";
import { AnnotationPhrase } from "@shared/models/annotation-phrase";
import { IndPhrase } from "@shared/models/cat.model";
import { AnchorResult, CopiedAnchorResult, ReferenceIssue, ReferencePhrase } from "@shared/models/common";
import { EmbeddedObjectAnnotation } from "@shared/models/embedded-object-annotation";
import { RevRule } from "@shared/models/rev.model";
import { CopyAnchorsCoordinatorService } from "@shared/services/copy-anchors-coordinator.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
@Component({
    selector: 'mng-anchors',
    templateUrl: './mng-anchors.component.html',
    styleUrls: ['./mng-anchors.component.scss'],
    standalone: false
})
export class MngAnchorsComponent implements OnInit, OnDestroy {
    
    @Output() anchorToRemove = new EventEmitter();

    @Output() viewPageAndRef = new EventEmitter();

    @Input() anchors: AnchorResult[];

    @Input() phrase: IndPhrase | RevRule;

    @Input() simpleView: boolean = false;

    @Input() displayActions: boolean = true;

    @Input() disableActions: boolean = false;
    
    @Input() enableRemoveAnchors: boolean = true;

    @Input() copyAnchors: boolean = false;

    @Input() editAnchorsPaths: boolean = true;

    @Input() workingRefAnchors: AnchorResult[];
    @Input() isMissingInWorkingPhrase: boolean = false;
    @Input() catMatchReference: ReferencePhrase | null = null;
    @Input() referenceIssue: ReferenceIssue | null = null;
    //anchors: AnnotationPhrase[];
    showConsistencyIssuePhrases: boolean = false;
    currEmbeddedObjectAnnotation: EmbeddedObjectAnnotation;

    @Output() anchorPathChange = new EventEmitter<void>();

    @Output() showRefDoc = new EventEmitter();
    editingConsistencyCheckResults: { [key: number]: boolean } = {};

    private onDestroy$ = new Subject();
    
    constructor(private copyAnchorsCoordinatorService: CopyAnchorsCoordinatorService) {}

    ngOnInit() {

    }

    viewAnchor(anchor: AnchorResult) {


        //this.viewPageAndRef.emit(consistencyCheckResult.embeddedObjectAnnotation);
        if (anchor.embeddedObjectAnnotation.boundingBox == undefined) {
            
            this.showRefDoc.emit();
            return;

        }
        this.currEmbeddedObjectAnnotation = anchor.embeddedObjectAnnotation;
        this.showConsistencyIssuePhrases = true;
    }

    removeAnchor(anchor: AnchorResult) {
        
        let index: number = this.anchors.indexOf(anchor);
        if (index != -1) {
            
            this.anchors.splice(index, 1);

           anchor.remove(this.phrase);
           if (this.phrase && anchor instanceof AnchorResult && this.anchors?.length == 0) {
            //deleted anchor result 
            let ref = this.phrase.references?.find((ref) => ref.anchors && ref.anchors == this.anchors);
            if (ref && ref.isConsistencyGenerated) {
                ref.isDeletedAnchor = true;
            }
           }
        }
        this.anchorToRemove.emit();

    } 

    getAnchorText(anchor: AnchorResult, numOfWords: number = 13): string {

        let phrase = anchor?.embeddedObjectAnnotation?.startingPhrase;

        if (!phrase) {
            return phrase;
        }

        const words = phrase.split(/\s+/); // split by whitespace
        if (words.length <= numOfWords) {
            return phrase;
        }

        return words.slice(0, numOfWords).join(" ") + " ...";     
    }

    getAnchorPath(consistencyCheckResult: AnchorResult) {

        return consistencyCheckResult?.embeddedObjectAnnotation?.anchorPath;
        
    }

    onFinishedTyping(event: any, anchor: AnchorResult) {

        if (!this.editAnchorsPaths) {
            return;
        }

        const userInput = (event.target as HTMLInputElement).value;
        this.editingConsistencyCheckResults[anchor.issueId] = false;
/*         
        if (anchor.isNewlyAdded) {
            const anchorToUpdate = this.phrase.consistencyIssuesToUpdate.add?.phrase_reference_consistency_check_results?.find(elem => elem.ref_doc_id == anchor.refDocId  && anchor.embeddedObjectAnnotation.anchorPath == elem.ref_doc_anchor_path)
            if (anchorToUpdate) {

                anchorToUpdate.ref_doc_anchor_path = userInput;
                anchor.embeddedObjectAnnotation.anchorPath = userInput;
            }
            return;
        }
        
        anchor.embeddedObjectAnnotation.anchorPath = userInput; */
        anchor.updateAnchorPath(userInput, this.phrase);
        this.anchorPathChange.emit();
        
    }


    hasAnchor(anchor: AnchorResult): boolean {
        

        return this.copyAnchorsCoordinatorService.hasAnchor(anchor, this.workingRefAnchors);
    }

    
    copyAnchor(anchor: AnchorResult) {

        if (this.isMissingInWorkingPhrase && this.catMatchReference != null) {
            
            let workingReference = this.copyAnchorsCoordinatorService.copyReferenceToWorkingPhrase(this.phrase, this.catMatchReference, this.referenceIssue);
            this.workingRefAnchors = workingReference.anchors;

        }
        this.copyAnchorsCoordinatorService.copyAnchor(anchor, this.workingRefAnchors, this.phrase);
        
        this.anchorPathChange.emit();
    }

    ngOnDestroy(): void {
        
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }

}